import update from "immutability-helper";
import { findIndex as _findIndex } from "lodash-es";

import * as actions from "../actions/circles";
import { FETCH_UPDATES_SUCCESS, SET_PENDING, SET_SAVED } from "../actions/sync";
import {
  makeObjectsSaved,
  setPendingFlag,
  updateFromFetchUpdates,
} from "../utils";

export default function circles(state = [], action) {
  switch (action.type) {
    case actions.CREATE_CIRCLE: {
      return update(state, {
        $push: [
          {
            id: action.payload.id,
            name: action.payload.name,
            humanIds: [],
            createdAt: new Date().toISOString(),
            modifiedAt: new Date().toISOString(),
            modified: true,
            pending: false,
          },
        ],
      });
    }

    case actions.DELETE_CIRCLE: {
      const circleIndex = state.findIndex((c) => c.id === action.id);
      return update(state, { $splice: [[circleIndex, 1]] });
    }

    case actions.ADD_HUMANS: {
      const circleIndex = state.findIndex(
        (c) => c.id === action.payload.circleId
      );
      return update(state, {
        [circleIndex]: {
          humanIds: { $push: action.payload.humanIds },
          $merge: { modified: true, modifiedAt: new Date().toISOString() },
        },
      });
    }

    case actions.REMOVE_HUMAN: {
      const circleIndex = state.findIndex(
        (c) => c.id === action.payload.circleId
      );
      const humanToRemove = state[circleIndex].humanIds.findIndex(
        (h) => h === action.payload.humanId
      );
      return update(state, {
        [circleIndex]: {
          humanIds: { $splice: [[humanToRemove, 1]] },
          $merge: { modified: true, modifiedAt: new Date().toISOString() },
        },
      });
    }

    case FETCH_UPDATES_SUCCESS: {
      return updateFromFetchUpdates(state, action.payload.data.circles);
    }

    case SET_PENDING: {
      return setPendingFlag(state, action.data.circle, action.pending);
    }

    case SET_SAVED: {
      return makeObjectsSaved(state, action.data.circle);
    }

    case actions.RENAME_CIRCLE: {
      const { circleId, name } = action;
      const circleIndex = _findIndex(state, { id: circleId });

      return update(state, {
        [circleIndex]: {
          $merge: { name: name, modified: true },
        },
      });
    }

    default:
      return state;
  }
}
